import { Grid } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '~/services/api';
import Loader from '~/ui/components/common/Loader';
import downloadFile from '~/utils/downloadFile';
import { extractErrorMessage } from '~/utils/error';
import { getFileNameFromContentDisposition } from '~/utils/headers';

interface IParams {
  acrsVersionId: string;
}

const MihinAcrsFiles = () => {
  const [message, setMessage] = useState(null);

  const { acrsVersionId: acrsVersionIdParams } = useParams<IParams>();

  const versionId = useMemo(() => Number(acrsVersionIdParams), [acrsVersionIdParams]);

  const onMount = async () => {
    try {
      const { data, headers } = await api.mihin.downloadMihinAcrsFiles(versionId);

      const fileName = getFileNameFromContentDisposition(headers['content-disposition']);

      const objectUrl = window.URL.createObjectURL(new Blob([data]));

      downloadFile(objectUrl, fileName);

      window.URL.revokeObjectURL(objectUrl);

      setMessage('The file is downloaded.');
    } catch (e) {
      setMessage(extractErrorMessage(e));
    }
  };

  useEffect(() => {
    onMount();
  }, []);

  return (
    <Grid container justifyContent="center">
      <Grid item>{message ?? <Loader />}</Grid>
    </Grid>
  );
};

export default MihinAcrsFiles;
